import React from 'react';
import PropTypes from 'prop-types';
import LoginFooter from '../LoginFooter/LoginFooter';

const ErrorResult = ({ handleAutoNav, handleNav, room }) => {
    const autoNavTimer = setTimeout(() => { handleAutoNav(history, room); }, 7500);
    return (
        <div className="grid-y medium-grid-frame">
            <div className="grid-x medium-grid-frame">
                <section className="cell">
                    <div className="grid-y medium-grid-frame grid-padding-x tx-kiosk__content">
                        <div className="cell auto cell-block-container">
                            <div className="cell auto cell-block-container cell-block-y align-middle align-center">
                                <div className="grid-y grid-padding-y tx-kiosk__message">
                                <i className="icon icon--warning-circle icon--size--xlarge icon--color--red" title="There's a Problem" aria-hidden="true" />
                                <h1 className="tx-kiosk__title tx-kiosk__title--large">There was a problem</h1>
                                <h2 className="tx-kiosk__copy">Please go to the main desk for more assistance.</h2>
                                </div>
                            </div>
                        </div>
                        <LoginFooter
                            buttonText="Go Back"
                            onClick={() => {
                                clearTimeout(autoNavTimer);
                                handleNav(history, room);
                            }} />
                    </div>
                </section>
            </div>
        </div>
    );
};

export default ErrorResult;

ErrorResult.propTypes = {
    handleAutoNav: PropTypes.func,
    handleNav: PropTypes.func,
    room: PropTypes.any,
};



// WEBPACK FOOTER //
// ./src/components/login-flow-components/ErrorResult/ErrorResult.jsx